(ns frontend.ui.component.lp-portal.report.body.lifeline.fund.fund-v.web
  (:require
   [frontend.ui.component.lp-portal.report.component.block-table.view :as block-table]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.view :as horizontal-table]
   [frontend.ui.component.lp-portal.report.component.overview-figures.view :as ov-figures]
   [frontend.ui.component.lp-portal.report.component.vertical-table.view :as vertical-table]
   [frontend.ui.component.lp-portal.voima-components.card.view :as card]
   [frontend.ui.component.lp-portal.voima-components.chart-card.chart-card :as chart-card]
   [frontend.ui.component.lp-portal.voima-components.free-text-card.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.voima-components.section.style :as section-style]
   [frontend.ui.component.lp-portal.voima-components.section.view :as section]
   [frontend.ui.component.lp-portal.voima-components.text-content.view :as text-content]
   [frontend.ui.style.theme.core :as theme]
   [herb.core :refer [<class]]))

(defn fund-update
  [{:keys [fund-update]} props]
  [:div
   [free-text-card/free-text-section "Fund update" fund-update props]])

(defn general
  [{:keys [general]} props]
  [:div
   [block-table/table "General" general (merge props {:fixed-width? true
                                                      :hide-footnote? true
                                                      :tabular-data-alignment "left"
                                                      :text-color (theme/color [:palette :white])})]])

(defn fund-progress
  [{:keys [fund-progress]} props]
  [:div {:style {:background-color (theme/color [:palette :granite])
                 :border-radius    "15px"}}
   [vertical-table/table "Fund progress" fund-progress (merge props {:hide-footnote?   true
                                                                     :stacked-rows?    true
                                                                     :background-color (theme/color [:palette :granite])
                                                                     :text-color       (theme/color [:palette :white])
                                                                     :expanded-title-color (theme/color [:palette :black])
                                                                     :title-color      (theme/color [:palette :white])})]])

(defn kpis
  [{:keys [kpis]} props]
  [:div
   [ov-figures/overview-figures-card kpis (merge props {:no-border? true})]])

(defn fund-progress-kpis-footnote
  [{:keys [fund-progress-kpis-footnote]} props]
  [:div
   [text-content/optional-footnote fund-progress-kpis-footnote props]])

(defn current-portfolio
  [{:keys [current-portfolio]} props]
  [:div
   [horizontal-table/table "Current portfolio" current-portfolio props]])

(defn exited-portfolio
  [{:keys [exited-portfolio]} props]
  [:div
   [horizontal-table/table "Exited portfolio" exited-portfolio props]])

(defn investment-summary
  [{:keys [investment-summary]} props]
  [:div
   [horizontal-table/table "Investment summary" investment-summary props]])

(defn investors
  [{:keys [investors]} props]
  [:div
   [horizontal-table/table "Investors" investors props]])

(defn capital-account-since-inception
  [{:keys [capital-account-since-inception]} props]
  [:div
   [horizontal-table/table "Capital account since inception" capital-account-since-inception props]])

(defn capital-account-quarter-to-date
  [{:keys [capital-account-quarter-to-date]} props]
  [:div
   [horizontal-table/table "Capital account quarter to date" capital-account-quarter-to-date props]])

(defn fund-cash-flows
  [{:keys [fund-cash-flows]} props]
  [:div
   [vertical-table/table "Fund cash flows" fund-cash-flows (merge props {:fixed-width? true})]])

(defn fund-assets
  [{:keys [fund-assets]} props]
  [:div
   [vertical-table/table "Fund assets" fund-assets (merge props {:fixed-width? true})]])

(defn management-fees
  [{:keys [management-fees]} props]
  [:div
   [vertical-table/table "Management fees" management-fees (merge props {:fixed-width? true})]])

(defn carried-interest
  [{:keys [carried-interest]} props]
  [:div
   [vertical-table/table "Carried interest" carried-interest (merge props {:fixed-width? true})]])

(defn fund-operating-expenses
  [{:keys [fund-operating-expenses]} props]
  [:div
   [vertical-table/table "Fund operating expenses" fund-operating-expenses (merge props {:fixed-width? true})]])

(defn total-investment
  [{:keys [chart-data-total-investment]} props]
  [chart-card/view
   "TOTAL INVESTMENT, m€"
   chart-data-total-investment
   (merge props {:hide-footnote? true
                 :preserve-title-case? true})])

(defn portfolio-at-fair-value
  [{:keys [chart-data-portfolio-at-fair-value]} props]
  [chart-card/view
   "PORTFOLIO AT FAIR VALUE, m€"
   chart-data-portfolio-at-fair-value
   (merge props {:hide-footnote? true
                 :preserve-title-case? true})])

(defn view
  [{:keys [fund-ui-data report] :as props}]
  (let [report-id (some->> report :db/id)]
    [:div
     [:div {:id (str "fund-overview-" report-id)}
      [section/section "Fund overview" (str "fund-overview-section-" report-id)
       [:<>
        [:div {:class (<class section-style/section-wrapper-alternative)}
         [card/card {:title ""
                     :background-color (theme/color [:palette :granite])}
          [fund-update fund-ui-data props]
          [fund-progress fund-ui-data props]]
         [kpis fund-ui-data props]
         [fund-progress-kpis-footnote fund-ui-data props]]
        [general fund-ui-data props]
        [total-investment fund-ui-data props]
        [portfolio-at-fair-value fund-ui-data props]]]]

     [:div {:id (str "portfolio-information-" report-id)}
      [section/section "Portfolio information" (str "portfolio-information-section-" report-id)
       [:<>
        [current-portfolio fund-ui-data props]
        [exited-portfolio fund-ui-data props]
        [investment-summary fund-ui-data props]]]]

     [:div {:id (str "investors-" report-id)}
      [section/section "Investors" (str "investors-section-" report-id)
       [:<>
        [investors fund-ui-data props]]]]

     [:div {:id (str "capital-accounts-" report-id)}
      [section/section "Capital accounts" (str "capital-accounts-section-" report-id)
       [:<>
        [capital-account-since-inception fund-ui-data props]
        [capital-account-quarter-to-date fund-ui-data props]]]]

     [:div {:id (str "cash-flows-and-fees-" report-id)}
      [section/section "Cash flows, assets and fees" (str "cash-flows-fees-section-" report-id)
       [:<>
        [fund-cash-flows fund-ui-data props]
        [fund-assets fund-ui-data props]
        [management-fees fund-ui-data props]
        [carried-interest fund-ui-data props]
        [fund-operating-expenses fund-ui-data props]]]]]))
